import { render, staticRenderFns } from "./ProfileTabsOtp.vue?vue&type=template&id=5743cff5"
import script from "./ProfileTabsOtp.vue?vue&type=script&lang=js"
export * from "./ProfileTabsOtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports